var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoursePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0134 102.842H126.54L126.577 127.091C126.571 131.33 123.131 134.758 118.892 134.758H47.0134C38.1979 134.758 31.0557 127.615 31.0557 118.8C31.0557 109.984 38.1979 102.842 47.0134 102.842Z",
    stroke: "#808080",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0557 118.792V35.8758C31.0557 26.6919 38.4977 19.25 47.6814 19.25H118.848C123.093 19.25 126.54 22.6963 126.54 26.9417V102.835",
    stroke: "#808080",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 119L127 119",
    stroke: "#808080",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4565 102.837V19.8516",
    stroke: "#808080",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6919 45.7689H88.1443M78.6919 64.3219H100.05",
    stroke: "#808080",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursePlaceholder);
export default __webpack_public_path__ + "static/media/CoursePlaceholder.2858875287c5333e4938e5812bd8e591.svg";
export { ForwardRef as ReactComponent };